export const environment = {
  production: import.meta.env.VITE_ENVIRONMENT !== 'local',
  spotifyStorageKey: 'spotify_token',
  spotifyApiBaseUrl: 'https://api.spotify.com/v1',
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sentryEnvironment: import.meta.env.VITE_ENVIRONMENT,
};
